import { DateOnly } from '@if/core/date'
import { t } from '@if/core/i18n'
import { dateOnly, InferSubmit, mixed, number, object, string } from '@if/core/yup'
import { EFeeType, VALID_FEE_TYPES } from '@src/types/constants'

/**
 * A fee is charged when it is added: it can be back-dated to the loan activation, never dated in the future. It is
 * always positive: it is lowered by editing it (see EditFee-schema), never by a negative fee.
 */
export const getAddFeeSchema = (activationDate: DateOnly, today: DateOnly) =>
  object({
    feeType: mixed<EFeeType>().oneOf(VALID_FEE_TYPES).required(),
    amount: number().required().moreThan(0),
    effectiveDate: dateOnly()
      .required()
      .min(activationDate, () => t('loan.feesDialog.errors.effectiveDateBeforeActivation'))
      .max(today, () => t('loan.feesDialog.errors.effectiveDateAfterToday')),
    note: string().notRequired().default(''),
  })

export type AddFeeSchemaType = InferSubmit<ReturnType<typeof getAddFeeSchema>>
